import React, { useState, useEffect, useRef } from "react";
import Modal from "../../Components/Base/Modal";
import "rc-slider/assets/index.css";

import { GalleryVideo } from "../../Components";
export default function ProfileAllPhotosModal({ galleryInfluencerImage, close }) {
  const [imageToShow, setImageToShow] = useState([]);
  const [showMorePage, setShowMorePage] = useState(0);
  const modalRef = useRef(null);

  useEffect(() => {
    if (galleryInfluencerImage && galleryInfluencerImage.length > 0) {
      const nextElements = getNextElements(galleryInfluencerImage, showMorePage);
      if (showMorePage === 0) {
        setImageToShow(nextElements);
      } else {
        setImageToShow(prev => [...prev, ...nextElements]);
      }
    }
  }, [galleryInfluencerImage, showMorePage]);

  function getNextElements(arr, pageIndex, count = 6) {
    const start = pageIndex * count;
    const end = start + count;
    return arr.slice(start, end);
  }

  const handleScroll = () => {
    if (!modalRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = modalRef.current;
    
    if (scrollHeight - scrollTop - clientHeight < 5 && imageToShow.length < galleryInfluencerImage.length) {
      setShowMorePage(prev => prev + 1);
    }
  };

  return (
    <Modal addClass="showallPhotos modalCamp" close={close}>
      <div className="p-6 md:p-8 bg-white rounded-3xl">
        <div className="flex justify-between items-center mb-6 pb-4 border-b border-gray-100">
          <div>
            <h2 className="text-2xl font-bold text-gray-800 m-0">Gallery Photos</h2>
            <p className="text-sm text-gray-500 mt-1 m-0">A visual look into the influencer's journey</p>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <span className="text-xs font-semibold text-emerald-600 bg-emerald-50 px-3 py-1.5 rounded-full border border-emerald-100 shadow-sm">
              {galleryInfluencerImage?.length || 0} Assets
            </span>
          </div>
        </div>

        {/* Media Grid */}
        <div 
          className="!grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-h-[65vh] overflow-y-auto pr-2 custom-scrollbar scroll-smooth"
          id="gallery-modal-grid"
          ref={modalRef} 
          onScroll={handleScroll}
        >
          {imageToShow.length > 0 ? (
            imageToShow.map((item, index) => {
              return item.media_type_id === 2 ? (
                <div
                  className="group relative w-full aspect-square rounded-2xl overflow-hidden bg-gray-100 border border-gray-100 transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl cursor-pointer"
                  key={index}
                  style={{ minHeight: '200px' }}
                >
                  <div
                    className="absolute inset-0 w-full h-full bg-cover bg-center"
                    style={{
                      backgroundImage: !item.media_url
                        ? `url(${process.env.PUBLIC_URL}/images/placeholder/list_image.jpg)`
                        : `url(${encodeURI(item.media_url)})`
                    }}
                  ></div>
                  <div className="absolute inset-0 bg-black/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
              ) : item.media_type_id === 1 ? (
                <div key={index} className="w-full aspect-square rounded-2xl overflow-hidden border border-gray-100 shadow-sm transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl bg-black" style={{ minHeight: '200px' }}>
                  <GalleryVideo 
                    media_url={item.media_url} 
                    status={'visible'} 
                    media_type_id={item.media_type_id} 
                  />
                </div>
              ) : null;
            })
          ) : (
            <div className="col-span-full py-20 text-center">
              <p className="text-gray-400 font-medium">No photos found in the gallery.</p>
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f8fafc;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #e2e8f0;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #cbd5e1;
        }
      `}</style>
    </Modal>
  );
}




